import { render, staticRenderFns } from "./delGroup.vue?vue&type=template&id=c8003ce2&scoped=true"
import script from "./delGroup.vue?vue&type=script&lang=js"
export * from "./delGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8003ce2",
  null
  
)

export default component.exports